export default {
    routerName: '外汇管理',
    exchange: {
        searchName: '检索条件',
        jpy: '100日元',
        usd: '1美元',
        hkd: '1港元',
        eur: '1欧元',
        gpb: '1英镑',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成时间',
        createStartTime: '开始时间',
        createEndTime: '结束时间',
    },
    table: {
        id: 'ID',
        jpy: '100日元',
        usd: '1美元',
        hkd: '1港元',
        eur: '1欧元',
        gpb: '1英镑',
        year: '年',
        month: '月',
        day: '日',
        createTime: '作成时间',
    },
};
